export default {
  'zh-CN': {
    text: '特殊字段展示区'
  },
  'en': {
    text: 'Special field display area'
  }
}
